var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import styles from './styles.module.scss';
import { Button } from 'template/lib';
Modal.setAppElement('#root');
var ModalEditAttendant = function (props) {
    var login = useAuth().login;
    var _a = useState([]), softwares = _a[0], setSoftwares = _a[1];
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    var formik = useFormik({
        initialValues: {
            softwareIds: []
        },
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.put("attendants/software/" + props.idAttendant, {
                                softwareIds: values.softwareIds
                            }, config)];
                    case 1:
                        _a.sent();
                        formik.resetForm();
                        props.handleCloseModalAttendantEdit();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.log(err_1);
                        alert('Erro ao editar atendente.');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    });
    useEffect(function () {
        api.get('helps/softwares', config).then(function (response) {
            setSoftwares(response.data);
        });
    }, []);
    useEffect(function () {
        if (props.modalIsOpenAttendant) {
            var ids = Array.isArray(props.idSoftware)
                ? props.idSoftware.map(function (id) { return Number(id); })
                : [];
            formik.setFieldValue('softwareIds', ids);
        }
    }, [props.modalIsOpenAttendant, props.idSoftware]);
    return (_jsx(Modal, __assign({ isOpen: props.modalIsOpenAttendant, shouldCloseOnOverlayClick: false, onRequestClose: props.handleCloseModalAttendantEdit, overlayClassName: 'react-modal-overly', className: 'react-modal-content', contentLabel: "Editar Atendente" }, { children: _jsxs("div", { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx("h2", __assign({ className: 'font-semibold border-b-2 text-lg' }, { children: "Editar Atendente" }), void 0), _jsx(AiOutlineClose, { title: 'Fechar', className: 'cursor-pointer text-sm', onClick: props.handleCloseModalAttendantEdit }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.content }, { children: _jsxs("form", __assign({ onSubmit: function (e) {
                            e.preventDefault();
                            formik.setFieldTouched('softwareIds', true, true);
                            formik.handleSubmit();
                        }, className: 'mx-4 my-4' }, { children: [_jsx("div", __assign({ className: 'grid justify-items-start' }, { children: _jsxs("div", __assign({ className: 'grid grid-cols-1 my-2 justify-items-end' }, { children: [_jsxs("div", __assign({ className: styles.multiSelectContainer }, { children: [_jsx("label", __assign({ className: styles.multiSelectLabel }, { children: "Softwares atendidos:" }), void 0), _jsx("div", __assign({ className: styles.multiSelectBox }, { children: softwares.map(function (software) {
                                                        var softwareId = Number(software.id);
                                                        var selected = formik.values.softwareIds.includes(softwareId);
                                                        return (_jsxs("label", __assign({ className: styles.multiSelectOption + " " + (selected ? styles.multiSelectOptionSelected : '') }, { children: [_jsx("input", { type: "checkbox", name: "softwareIds", value: softwareId, checked: selected, onChange: function (e) {
                                                                        var currentIds = formik.values.softwareIds;
                                                                        if (e.target.checked) {
                                                                            formik.setFieldValue('softwareIds', __spreadArray(__spreadArray([], currentIds), [softwareId]));
                                                                        }
                                                                        else {
                                                                            formik.setFieldValue('softwareIds', currentIds.filter(function (id) { return id !== softwareId; }));
                                                                        }
                                                                        formik.setFieldTouched('softwareIds', true, false);
                                                                    } }, void 0), _jsx("span", { children: software.name }, void 0)] }), softwareId));
                                                    }) }), void 0)] }), void 0), formik.errors.softwareIds && formik.touched.softwareIds && (_jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.softwareIds }), void 0))] }), void 0) }), void 0), _jsx("div", __assign({ className: styles.flexButton }, { children: _jsx(Button, __assign({ type: 'submit' }, { children: "Salvar" }), void 0) }), void 0)] }), void 0) }), void 0)] }, void 0) }), void 0));
};
export default ModalEditAttendant;
